/* eslint-disable react-hooks/rules-of-hooks */
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Box from "@mui/material/Box";
import { GridColDef, GridPinnedColumnFields } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import {
    Button,
    IconButton,
    TextField,
    AvatarGroup,
    Avatar,
    Divider,
    styled,
    Dialog,
    Alert,
    Tooltip,
    Autocomplete
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import Grid from "@mui/material/Grid2";
import Chip from "@mui/material/Chip";
import { ThreeDot } from "react-loading-indicators";
import emptyImage from "../../assets/images/image.png";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { showToast } from "../../Components/Toast";
import { Link, useLocation } from "react-router-dom";
import {
    getCustomerRfqPartDetails,
    getCustomerRfqGeneralDetails,
    updateArchiveAndUnarchiveApi,
    createRfqFeasibleForm,
    getApprovalStatusDetails,
    createRfqFinalApprovalByKamHeadForm,
    getRfqFinalApprovalReportStatusApi,
    getApproversImg,
    getCustomerRfqPartForPartialApproval,
    getDepartment,
    saveDroppedCorfq
} from "../Services/OrgRepo";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {
    accountManager,
    accountManagerHead,
    NPDManagerHead,
    getLoggedInUserID,
    productionManagerHead,
    qualityManagerHead,
    sourcingManager,
    sourcingManagerHead,
    generatProfilePicUrl,
    getLoggedInEmail,
    Management,
    formatCurrencyValue
} from "../../Utils/Constant";
import { ApprovalStatusDrawer } from "./ApprovalStatusDrawer";
import { DrawingDrawer } from "./DrawingDrawer";
import { PartsDrawer } from "./PartsDrawer";
import { notificationUpdateReadStatusApi } from "../../Sourcing/Services/Notification/Notification";
import { WebsocketContext } from "../../App";
import {
    getDrawingStepFileDownload,
    uploadRfqPartFileAPI
} from "../Services/FeasibleRFQ";
import { StepFile } from "./StepFilePartDrawer";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import fileImg from "../../assets/images/file.png";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import EuroIcon from "@mui/icons-material/Euro";
import pdfFileImg from "../../assets/images/pdfIcon.png";
import StepFileView from "../autosdk/StepFileView";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { log } from "node:console";
import { logDOM } from "@testing-library/dom";

const getCurrencyIcon = (currency) => {
    switch (currency) {
        case "INR":
            return <CurrencyRupeeIcon sx={{ fontSize: "0.875rem" }} />;
        case "USD":
            return <AttachMoneyIcon sx={{ fontSize: "0.875rem" }} />;
        case "EUR":
            return <EuroIcon sx={{ fontSize: "0.875rem" }} />;
        default:
            return null;
    }
};

const StyledTableCell = styled(TableCell)({
    fontWeight: "bold",
    color: "#00000099",
    padding: "6px 10px",
    border: "none"
});

const StyledBodyCell = styled(TableCell)({
    padding: "6px 10px",
    border: "none"
});

const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
    background: "none"
});

interface GeneralDetails {
    id: number;
    companyName: string;
    companyRfqID: string;
    rfqName: string;
    addedOn: string;
    rfqStartDate: string;
    rfqEndDate: string;
    preferredCurrency: string;
    totalOrderValue: any;
    typeOfOrder: string;
    industryType: string;
    mandatoryCertifications: string[];
    isNew: string;
    notificationID: string;
    currency: string;
    priceType: string;
    keyAccountManager: string;
    keyAccountManagerProfilePath: string;
    keyAccountManagerID: any;
    departmentId: string;
    droppedByKamHead: string;
    addedTime: string;
    droppedReason: string;
    isDropped: boolean;
}
interface FeasibleDetails {
    status: string;
    reason: string;
}
interface Approver {
    profileFileID: string;
    profileFileName: string;
    profileName: string;
}
export const CURFQDetails = () => {
    const location = useLocation();
    // const rfqData = location?.state?.rfqData;
    // const from = location?.state?.from;
    const storedData = JSON.parse(
        localStorage.getItem("CURFQDetails") || "null"
    );
    const routePayload = location?.state?.payload;
    const tabStoredData = JSON.parse(
        sessionStorage.getItem("CURFQDetailsTab") || "null"
    );
    const pageData =
        location?.state?.rfqData || routePayload?.rfqData
            ? {
                  rfqData: location?.state?.rfqData || routePayload?.rfqData,
                  from: location?.state?.from || routePayload?.from
              }
            : tabStoredData || storedData;
    const rfqData = pageData?.rfqData;
    const from = pageData?.from;

    useEffect(() => {
        if (pageData?.rfqData?.ID || pageData?.rfqData?.rfqID) {
            sessionStorage.setItem("CURFQDetailsTab", JSON.stringify(pageData));
        }
    }, [pageData]);

    const currentLoggedInUser = getLoggedInUserID();
    const [loading, setLoading] = useState<boolean>(false);
    const [departments, setDepartments] = useState<
        { Department_Name: string; Department_ID: string }[]
    >([]);
    const [selectedDepartment, setSelectedDepartment] = useState<{
        Department_Name: string;
        Department_ID: string;
    } | null>(null);
    const [approvers, setApprovers] = useState<Approver[]>([]);
    const [value, setValue] = React.useState("1");
    const [searchTerm, setSearchTerm] = useState("");
    const [rows, setRows] = useState<Record<string, any>[]>([]);
    const [archiveCount, setArchiveCount] = useState(0);
    const [rowsGd, setRowsGd] = useState<GeneralDetails | null>(null);
    const [isAllReviewed, setIsAllReviewed] = useState<boolean>(false);
    const [isRfqDateEnd, setIsRfqDateEnd] = useState<boolean>(false);
    const [reasonForStatus, setReasonForStatus] = useState<string>("");
    const [actionType, setActionType] = React.useState("");
    const [isStatusUpdated, setIsStatusUpdated] = useState<boolean>(false);
    const [filteredRows, setFilteredRows] = useState(rows);
    const [selectedRows, setSelectedRows] = useState<string[]>([]);
    const [RowsForArchiveAndUnarchive, setRowsForArchiveAndUnarchive] =
        useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isArchiveOrUnarchiveLoading, setIsArchiveOrUnarchiveLoading] =
        useState<boolean>(false);
    const searchInputRef = useRef<HTMLInputElement>(null);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [openDialog, setOpen] = React.useState(false);
    const [openDialogAR, setOpenAR] = React.useState(false);
    const [selectedRowData, setSelectedRowData] = useState<any>(null);
    const [openDrawerDrawing, setOpenDrawerDrawing] = useState(false);
    const [feasibleReportDetails, setFeasibleReportDetails] =
        useState<FeasibleDetails | null>(null);
    const [finalApprovalReportDetails, setFinalApprovalReportDetails] =
        useState<FeasibleDetails | null>(null);
    const [statusPresentense, setStatusPresentense] = React.useState("");
    const [selectedPartValues, setSelectedPartValues] = useState([]);
    const [openDrawerParts, setOpenDrawerParts] = useState(false);
    const [deleteStepFile, setDeleteStepFile] = useState(false);
    const [openDrawerStepFile, setOpenDrawerStepFile] = useState(false);
    const [getUpdateStatus, setGetUpdateStatus] = useState(false);
    const [partiallyApproveParts, SetPartiallyApproveParts] = useState([]);
    const [rfqId, setRfqId] = useState();
    const [rfqName, setRfqName] = useState();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isCopoCreated, setIsCopoCreated] = useState(false);
    const [dropInfo, setDropInfo] = useState({
        isDropped: false,
        droppedTime: "",
        droppedBy: "",
        dropReason: ""
    });

    // const handleOpenStepFile = (rowData: any) => {
    //   setSelectedRowData(rowData);
    //   setOpenDrawerStepFile(true);
    //   setDeleteStepFile(false);
    // };

    const handleOpenStepFile = async (rowData: any) => {
        // Always fetch fresh row from backend before opening drawer
        const response = await getCustomerRfqPartDetails(rfqData?.rfqID, "No");
        if (response?.status) {
            const updatedRow = response?.data.find(
                (item) => item?.partID === rowData?.partID
            );
            setSelectedRowData(updatedRow);
        } else {
            setSelectedRowData(rowData);
        }
        setOpenDrawerStepFile(true);
        setDeleteStepFile(false);
    };

    const handleCloseStepFile = () => {
        setSelectedRowData(null);
        setOpenDrawerStepFile(false);
    };
    const { updateIsReadStatus, setUpdateIsReadStatus } =
        useContext(WebsocketContext);
    const handleOpenDrawerDrawing = (rowData: any) => {
        setSelectedRowData(rowData);
        setOpenDrawerDrawing(true);
    };
    const handleCloseDrawerDrawing = () => {
        setOpenDrawerDrawing(false);
    };
    const handleOpenDrawer = () => {
        setOpenDrawer(true);
    };

    const handleCloseDrawer = () => {
        setOpenDrawer(false);
    };
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setRowsForArchiveAndUnarchive([]);
        setSelectedRows([]);
    };
    const handleOpenPartsDrawer = () => {
        setOpenDrawerParts(true);
    };
    const handleClosePartsDrawer = () => {
        setOpenDrawerParts(false);
    };
    const handleClickOpenAR = async (type) => {
        setActionType(type);
        const statusPresentense =
            type === "Approved"
                ? "approve"
                : type === "Rejected"
                  ? "reject"
                  : type === "Partially Approved"
                    ? "partially approve"
                    : type === "Dropped"
                      ? "Drop"
                      : "";
        setStatusPresentense(statusPresentense);
        setOpenAR(true);
        if (type === "Partially Approved") {
            const response = await getCustomerRfqPartForPartialApproval(
                rfqData?.rfqID
            );
            if (response?.data) {
                // const data = response?.data?.map((item) => {
                //   return { title: item?.partName, partID: item?.partID };
                // });
                SetPartiallyApproveParts(response?.data);
            }
        }
    };

    const handleCloseAR = () => {
        setActionType("");
        setSelectedDepartment({ Department_ID: "", Department_Name: "" });
        setReasonForStatus("");
        setOpenAR(false);
    };

    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 10 // Default page size
    });

    const [pinnedColumns, setPinnedColumns] =
        React.useState<GridPinnedColumnFields>({
            left: ["__check__", "partNumber", "partName"]
        });
    const handlePinnedColumnsChange = React.useCallback(
        (updatedPinnedColumns: GridPinnedColumnFields) => {
            setPinnedColumns(updatedPinnedColumns);
        },
        []
    );

    const archiveAndUnarchiveApi = async (status: any) => {
        setIsArchiveOrUnarchiveLoading(true);
        try {
            let partIds = RowsForArchiveAndUnarchive?.map(
                (item) => item?.partID
            );
            let payload = { partIds: partIds, Archived: status };
            const updateRespose = await updateArchiveAndUnarchiveApi(payload);
            setOpen(false);
            if (updateRespose?.status) {
                fetchCustomerRfqPartDetailsData(rfqData?.rfqID);
            }
            handleClose();
            setIsArchiveOrUnarchiveLoading(false);
        } catch (error) {
            // handleCloseAR();
            setIsArchiveOrUnarchiveLoading(false);
        }
    };

    const fetchDepartment = async () => {
        try {
            const data = await getDepartment();
            if (data?.data?.Select_Department) {
                setDepartments(data?.data?.Select_Department);
            }
        } catch (error) {
            console.error("Error fetching approvers:", error);
        }
    };

    const fetchApproversImg = async () => {
        try {
            const data = await getApproversImg(rfqData?.ID);
            if (data) {
                setApprovers(data?.data);
            }
        } catch (error) {
            console.error("Error fetching approvers:", error);
        }
    };
    const handleArchiveAndUnarchive = (str: string) => {
        archiveAndUnarchiveApi(str);
    };

    const fetchCustomerRfqPartDetailsData = async (params: string) => {
        setIsLoading(true);
        try {
            const response = await getCustomerRfqPartDetails(
                params,
                value === "2" ? "Yes" : "No"
            );
            setIsLoading(false);
            if (response?.status) {
                let data = response?.data?.map((item: any, index: number) => ({
                    id: index + 1,
                    partGeneratedID: item?.partGeneratedID || "-",
                    partID: item?.partID || `P${index + 1}`, // Generate an ID if missing
                    partNumber: item?.partNumber || "-",
                    title: item?.partName || "-",
                    partName: item?.partName || "-",
                    solution: item?.solution.join(", "),
                    rawMaterial: item?.rawMaterial || "-",
                    drawings: item?.drawings,
                    additionalDrawingsPath: item?.additionalDrawingsPath || "-",
                    targetPrice: item?.targetPrice || 0,
                    suggestedPrice: item?.suggestedPrice || 0,
                    quantity: item?.quantity || "-",
                    uom: item?.uom || "-",
                    totalOrderValue: item?.totalOrderValue || "-",
                    leadTime: item?.leadTime || "-",
                    rfqId: item?.rfqId || "-",
                    rfqName: item?.rfqName || "-",
                    process: item?.process || "-",
                    mandatoryInspection: item?.mandatoryInspection || "-",
                    packing: item?.packing || "-",
                    sampleRequired: item?.sampleRequired || "-",
                    typeOfOrder: item?.typeOfOrder || "-",
                    incoTerms: item?.incoTerms || "-",
                    qty_yr: item?.qty_yr || "-",
                    qty_batch: item?.qty_batch || "-",
                    keyAccountManager: item?.keyAccountManager || "-",
                    stepUploadedFile: item?.stepUploadedFile || "",
                    documentsToBeSubmitted: item?.documentsToBeSubmitted || "-",
                    currency: item?.currency || "-",
                    stepFileUrn: item?.stepFileUrn || "-"
                }));
                setArchiveCount(response?.count);
                setRows(data);

                setFilteredRows(data);
            } else {
                setArchiveCount(0);
                setRows([]);
                setFilteredRows([]);
            }
        } catch (error) {
            setArchiveCount(0);
            setIsLoading(false);
            setRows([]);
            setFilteredRows([]);
        }
    };

    const fetchCustomerRfqGeneralDetailsData = async (params: string) => {
        setIsLoading(true);
        try {
            const response = await getCustomerRfqGeneralDetails(params);
            setIsLoading(false);

            if (response?.status && response?.data?.length > 0) {
                const item = response?.data[0]; // Get the first item from the response

                setIsCopoCreated(Boolean(item?.General_Details?.isCopoCreated));

                const data: GeneralDetails = {
                    id: 1, // Static ID since there's only one record
                    companyName: item?.General_Details?.companyName || "-",
                    companyRfqID: item?.General_Details?.companyRfqID || "-",
                    rfqName: item?.General_Details?.rfqName || "-",
                    addedOn: item?.General_Details?.addedOn || "-",
                    rfqStartDate: item?.General_Details?.rfqStartDate || "-",
                    rfqEndDate: item?.General_Details?.rfqEndDate || "-",
                    isNew: item?.General_Details?.isNew,
                    notificationID: item?.General_Details?.notificationID,
                    preferredCurrency:
                        item?.General_Details?.preferredCurrency || "-",
                    totalOrderValue:
                        item?.General_Details?.totalOrderValue || "-",
                    typeOfOrder: item?.General_Details?.typeOfOrder || "-",
                    priceType: item?.General_Details?.priceType || "-",
                    droppedByKamHead: item?.General_Details?.droppedByKamHead,
                    addedTime: item?.General_Details?.addedTime,
                    droppedReason: item?.General_Details?.droppedReason,
                    isDropped: item?.General_Details?.isDropped,
                    industryType: item?.General_Details?.industryType || "-",
                    departmentId: item?.General_Details?.departmentId || "-",
                    keyAccountManagerID:
                        item?.General_Details?.keyAccountManagerID,
                    keyAccountManager:
                        item?.General_Details?.keyAccountManager || "-",
                    keyAccountManagerProfilePath:
                        item?.General_Details?.keyAccountManagerProfilePath,
                    mandatoryCertifications: Array.isArray(
                        item?.Mandatory_Certifications
                    )
                        ? item?.Mandatory_Certifications
                        : [], // Ensure it's always an array
                    currency: item?.General_Details?.currency || "-"
                };

                checkRfqEndDate(item?.General_Details?.rfqEndDate || "-");
                setRowsGd(data);
                setRfqId(response?.data[0]?.General_Details?.companyRfqID);
                setRfqName(response?.data[0]?.General_Details?.rfqName);
            } else {
                setRowsGd(null);
            }
        } catch (error) {
            setIsLoading(false);
            setRowsGd(null);
        }
    };
    const handleAllFilesDownload = async () => {
        setLoading(true);
        try {
            const response = await getDrawingStepFileDownload(rfqId, rfqName);
            if (response !== true) {
                showToast({
                    message: "No files found",
                    type: "error"
                });
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);

            showToast({
                message: "No files found",
                type: "error"
            });
            console.error("Error while downloading files", error);
        }
    };

    const checkRfqEndDate = (rfqEndDate: string) => {
        const rfqDate = new Date(rfqEndDate);
        const today = new Date();
        rfqDate?.setHours(0, 0, 0, 0);
        today?.setHours(0, 0, 0, 0);
        if (today <= rfqDate) {
            setIsRfqDateEnd(true);
        } else {
            setIsRfqDateEnd(false);
        }
    };

    const fetchRfqFeasibilityStakeHolderDetailsData = async (rfqID) => {
        setIsLoading(true);
        try {
            const response = await getApprovalStatusDetails(rfqID?.ID);
            console.log("kjfhjs----", response);
            setIsLoading(false);
            if (
                response?.status &&
                Array.isArray(response?.data) &&
                response?.data?.length > 0
            ) {
                let hasPending = false;
                let isCoRfq = false;
                for (const item of response?.data) {
                    if (item?.review === "Pending") {
                        console.log("if condition working");
                        hasPending = true;
                    }

                    if (
                        currentLoggedInUser === item?.deptHeadID &&
                        Number(rfqID?.ID) === Number(item?.coRfqID)
                    ) {
                        if (
                            item?.review !== "Pending" &&
                            item?.review !== "Verdict Not Given"
                        ) {
                            const feasibleDetails = {
                                status: item?.review,
                                reason: item?.comments
                            };
                            setFeasibleReportDetails(feasibleDetails);

                            isCoRfq = true;
                        } else {
                            const feasibleDetails = {
                                status: item?.review || "Pending",
                                reason: ""
                            };
                            setFeasibleReportDetails(feasibleDetails);
                        }
                    }
                }

                setIsAllReviewed(!hasPending);
                if (isCoRfq) {
                    setIsStatusUpdated(true);
                }
            } else {
                // showToast({
                //   message: response?.message || "No data found",
                //   type: "error",
                // });
            }
        } catch (error) {
            setIsLoading(false);
            // showToast({
            //   message: error?.message || "An error occurred",
            //   type: "error",
            // });
        }
    };

    let getToastType = (
        actionType: string
    ): "success" | "error" | "warn" | "info" => {
        switch (actionType?.toLowerCase()) {
            case "approved":
                return "success";
            case "partially approved":
                return "warn";
            case "rejected":
                return "error";
            case "dropped":
                return "warn";
            case "":
            case null:
            case undefined:
                return "error";
            default:
                return "info"; // fallback must be one of the allowed types
        }
    };

    const handleStatusUpdate = async (status: string, reason: string) => {
        if (isSubmitting) return; // prevent double clicks
        setIsSubmitting(true);
        setGetUpdateStatus(false);
        const allPartIds = rows
            ?.map((item: any) => item?.partID)
            ?.filter((id: string) => Boolean(id));
        var payload = {
            notifierEmail: "",
            companyRfqID: "",
            approvalStatus: "",
            reason: "",
            partIDs: []
            // Actor: getLoggedInUserID(),
            // notifierId: "88342000013428112",
        };

        if (actionType === "Partially Approved") {
            payload.notifierEmail = getLoggedInEmail();
            payload.companyRfqID = rowsGd?.companyRfqID;
            payload.approvalStatus = status;
            payload.reason = reason;
            payload.partIDs = selectedPartValues;
        } else {
            payload.notifierEmail = getLoggedInEmail();
            payload.companyRfqID = rowsGd?.companyRfqID;
            payload.approvalStatus = status;
            payload.reason = reason;
            payload.partIDs = allPartIds;
        }

        try {
            const statusUpdateOfRfqFeasible =
                await createRfqFeasibleForm(payload);

            if (statusUpdateOfRfqFeasible?.status === true) {
                setGetUpdateStatus(true);

                showToast({
                    message: `${rfqData?.rfqID} ${actionType}`,
                    type: getToastType(actionType)
                });
                // fetchPartnerData("New");
                setOpenAR(false);
                setReasonForStatus("");
                setIsStatusUpdated(true);
            } else {
                setOpenAR(false);
                setIsStatusUpdated(false);
            }
        } catch (err) {
            setIsStatusUpdated(false);
        } finally {
            setIsSubmitting(false); // re-enable button after response
        }
    };

    const checkFinalApprovalStatus = async (rfqID: string) => {
        const getApproverFinalStatuResponse =
            await getRfqFinalApprovalReportStatusApi(rfqID);
        const finalApprovalDetails = {
            status: getApproverFinalStatuResponse?.data[0]?.Approval_Status,
            reason: getApproverFinalStatuResponse?.data[0]?.Reason,
            rfqEndDate: getApproverFinalStatuResponse?.data[0]?.RFQ_End_Date
        };

        setFinalApprovalReportDetails(finalApprovalDetails);
    };

    const handleStatusUpdateByKamHead = async (
        status: string,
        reason: string
    ) => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        setGetUpdateStatus(false);

        var payload = {
            finalApprovalStatus: "",
            companyRfq: "",
            reason: "",
            department: ""
            // departmentName: "",
        };

        console.log("payload", payload);

        payload.finalApprovalStatus = status;
        payload.companyRfq = rowsGd?.companyRfqID;
        payload.reason = reason;
        payload.department = selectedDepartment?.Department_ID;
        // payload.departmentName = selectedDepartment?.Department_Name;

        try {
            let statusUpdateOfRfqFeasible;
            if (status === "Dropped") {
                const droppedCorfqPayload = {
                    Entity: "RFQ Drop",
                    Reason: reason || "",
                    Department: rowsGd?.departmentId,
                    Actor: rowsGd?.keyAccountManagerID,
                    Company_RFQ: rowsGd?.companyRfqID,
                    Notifier: "",
                    Name_of_the_Company: rowsGd?.companyName,
                    Key_Account_Manager: rowsGd?.keyAccountManager,
                    Key_Account_Manager_ID: getLoggedInUserID(),
                    Total_Order_Value: rowsGd?.totalOrderValue
                };

                console.log(droppedCorfqPayload, "droppedCorfqPayload");

                statusUpdateOfRfqFeasible =
                    await saveDroppedCorfq(droppedCorfqPayload);
                setDropInfo((prev) => ({
                    ...prev,
                    isDropped: statusUpdateOfRfqFeasible?.data?.isDropped,
                    droppedTime: statusUpdateOfRfqFeasible?.data?.addedTime,
                    dropReason: statusUpdateOfRfqFeasible?.data?.droppedReason,
                    droppedBy: statusUpdateOfRfqFeasible?.data?.droppedByKamHead
                }));
                console.log(
                    "statusUpdateOfRfqFeasible **",
                    statusUpdateOfRfqFeasible?.data?.addedTime
                );
            } else {
                statusUpdateOfRfqFeasible =
                    await createRfqFinalApprovalByKamHeadForm(payload);
            }

            if (statusUpdateOfRfqFeasible?.status === true) {
                setGetUpdateStatus(true);

                showToast({
                    message: `${rfqData?.rfqID} ${actionType}`,
                    type: getToastType(actionType)
                });
                // fetchPartnerData("New");
                setOpenAR(false);
                setReasonForStatus("");
                setIsStatusUpdated(true);
                await checkFinalApprovalStatus(rfqData?.ID);
                // if (status === "Dropped") {
                //     setIsDropped(true);
                // }
            } else {
                setOpenAR(false);
                setIsStatusUpdated(false);
            }
        } catch (err) {
            setIsStatusUpdated(false);
        } finally {
            setIsSubmitting(false);
        }
    };

    const lastFetchedId = useRef(null);

    useEffect(() => {
        if (getUpdateStatus) {
            checkFinalApprovalStatus(rfqData?.ID);
            fetchRfqFeasibilityStakeHolderDetailsData(rfqData);
            setAnchorEl(null);
        }
        if (!rfqData?.ID) return;

        // Only run if rfqData.ID has changed
        if (lastFetchedId?.current === rfqData?.ID) return;
        checkFinalApprovalStatus(rfqData?.ID);
        fetchRfqFeasibilityStakeHolderDetailsData(rfqData);
        setIsStatusUpdated(false);

        setAnchorEl(null);

        lastFetchedId.current = rfqData?.ID;
    }, [rfqData?.ID, getUpdateStatus]);

    // ✅ First useEffect (General Details + Approver Image)
    const lastGeneralDetailsId = useRef(null);

    useEffect(() => {
        if (!rfqData?.rfqID) return;

        if (lastGeneralDetailsId?.current === rfqData?.rfqID) return;

        fetchCustomerRfqGeneralDetailsData(rfqData?.rfqID);
        fetchApproversImg();
        fetchDepartment();
        lastGeneralDetailsId.current = rfqData?.rfqID;
    }, [rfqData]);

    // ✅ Second useEffect (Part Details)
    const lastPartDetailsId = useRef(null);
    const lastValue = useRef(null);

    useEffect(() => {
        if (deleteStepFile) {
            fetchCustomerRfqPartDetailsData(rfqData?.rfqID);
        }
        if (!value || !rfqData?.rfqID) return;

        const isSameRfqID = lastPartDetailsId.current === rfqData?.rfqID;
        const isSameValue = lastValue.current === value;

        if (isSameRfqID && isSameValue) return;

        fetchCustomerRfqPartDetailsData(rfqData?.rfqID);
        lastPartDetailsId.current = rfqData?.rfqID;
        lastValue.current = value;
    }, [value, deleteStepFile, rfqData?.rfqID]);

    useEffect(() => {
        if (
            (rfqData?.message?.includes("Approved") ||
                rfqData?.message?.includes("Rejected")) &&
            (accountManager() || accountManagerHead())
        ) {
            if (approvers?.length > 0) {
                setOpenDrawer(true);
            }
            //delete rfqData.message;
        }
    }, [rfqData, approvers]);
    // Handle tab change
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
        setSearchTerm(""); // Clear search when switching tabs
        setFilteredRows(rows); // Reset to all rows
        setSelectedRows([]);
    };

    // Handle search input change
    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const search = event?.target?.value;
        setSearchTerm(search);

        if (search?.length >= 3) {
            const filtered = rows?.filter((row) =>
                ["partNumber", "partName"].some(
                    (key) =>
                        typeof row[key] === "string" &&
                        row[key]?.toLowerCase().includes(search?.toLowerCase())
                )
            );
            setFilteredRows(filtered);
        } else {
            setFilteredRows(rows);
        }
    };
    const handleRefreshAfterUpload = async () => {
        await fetchCustomerRfqPartDetailsData(selectedRowData?.rfqId);

        // ✅ Re-select updated row (so prop reference changes)
        const updated = rows.find((r) => r.partID === selectedRowData.partID);
        if (updated) {
            setSelectedRowData(updated); // this triggers re-render in drawer
        }
    };
    const handleSelectionChange = (selection: any) => {
        const selectedRowData = rows?.filter((row, index) =>
            selection?.includes(index + 1)
        );
        setRowsForArchiveAndUnarchive(selectedRowData);
        setSelectedRows(selection);
    };

    useEffect(() => {
        if (searchInputRef?.current) {
            searchInputRef?.current?.focus();
        }
    }, [searchTerm]);

    const UploadFile = ({ params }) => {
        // const allowedExtensions = [
        //   "dwg",
        //   "DWG",
        //   "dxf",
        //   "DXF",
        //   "stp",
        //   "STP",
        //   "sldprt",
        //   "SLDPRT",
        //   "sldasm",
        //   "SLDASM",
        //   "slddrw",
        //   "SLDDRW",
        //   "step",
        //   "STEP",
        //   "iges",
        //   "IGES",
        //   "igs",
        //   "IGS",
        // ];
        const allowedExtensions = ["dwg", "stp", "step"];
        const maxFileSizeMB = 50;

        const [fileName, setFileName] = useState<string>(
            params?.row?.stepUploadedFile
        );
        const [fileUploadLoading, setFileUploadLoading] = useState(0);
        const handleFileChange = async (
            event: React.ChangeEvent<HTMLInputElement>
        ) => {
            const selectedFile = event?.target?.files?.[0];
            if (!selectedFile) return;

            const fileExtension = selectedFile?.name
                ?.split(".")
                .pop()
                ?.toLowerCase();
            const fileSizeMB = selectedFile?.size / (1024 * 1024);

            if (
                !fileExtension ||
                !allowedExtensions?.includes(fileExtension.toLowerCase())
            ) {
                showToast({
                    type: "error",
                    message: `Invalid file type ${fileExtension}. Allowed file types: ${allowedExtensions
                        ?.map((ext) => `.${ext}`)
                        .join(", ")}`
                });
                return;
            }

            if (fileSizeMB > maxFileSizeMB) {
                alert(`File size exceeds ${maxFileSizeMB} MB.`);
                return;
            }

            const file = event.target.files?.[0];
            if (file) {
                try {
                    setFileUploadLoading(params?.row?.partID);
                    const response = await uploadRfqPartFileAPI({
                        rfqPartId: params?.row?.partID,
                        fileUpload: file
                    });
                    if (response?.saveFileResponse?.status) {
                        setFileUploadLoading(0);
                        await fetchCustomerRfqPartDetailsData(
                            params?.row?.rfqId
                        );
                        showToast({
                            type: "success",
                            message: "Uploaded successfully"
                        });
                    } else {
                        setFileUploadLoading(0);
                    }
                } catch (err) {
                    setFileUploadLoading(0);

                    showToast({
                        type: "error",
                        message: "Failed to upload File"
                    });
                }
            }
        };
        const handleFileClick = () => {
            if (fileName) {
                handleOpenStepFile(params?.row);
            }
        };

        return (
            <>
                {accountManager() &&
                finalApprovalReportDetails?.status !== "Approved" &&
                finalApprovalReportDetails?.status !== "Rejected" ? (
                    <Button
                        component="label"
                        tabIndex={-1}
                        disabled={dropInfo?.isDropped}
                        sx={{
                            backgroundColor: "transparent",
                            boxShadow: "none",
                            padding: 0,
                            minWidth: 0,
                            fontSize: "0.875rem",
                            color: !fileName ? "primary" : "black"
                        }}
                        startIcon={
                            params?.row?.partID !== fileUploadLoading &&
                            !fileName ? (
                                <UploadFileIcon />
                            ) : (
                                ""
                            )
                        }
                    >
                        {fileName ? (
                            <Chip
                                label={
                                    <span
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                            overflow: "hidden"
                                        }}
                                    >
                                        <img
                                            src={fileImg}
                                            width="20px"
                                            alt="file"
                                        />
                                        3D File
                                    </span>
                                }
                                size="small"
                                className="hoverClr"
                                style={{
                                    cursor: "pointer",
                                    wordBreak: "break-all"
                                }}
                                onClick={handleFileClick}
                            ></Chip>
                        ) : params?.row?.partID !== fileUploadLoading ? (
                            <>
                                Upload 3D File
                                <VisuallyHiddenInput
                                    type="file"
                                    onChange={handleFileChange}
                                    multiple
                                />
                            </>
                        ) : (
                            <>Uploading...</>
                        )}
                    </Button>
                ) : fileName ? (
                    <Tooltip title={fileName}>
                        <Chip
                            size="small"
                            label={
                                <span
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        overflow: "hidden"
                                    }}
                                >
                                    <img
                                        src={fileImg}
                                        width="20px"
                                        alt="file"
                                    />
                                    {/* {fileName} */}
                                    3D File
                                </span>
                            }
                            className="hoverClr"
                            style={{
                                cursor: "pointer",
                                wordBreak: "break-all"
                            }}
                            onClick={handleFileClick}
                        ></Chip>
                    </Tooltip>
                ) : (
                    "No file uploaded"
                )}
            </>
        );
    };

    const IndustryTypeCell = ({ value }: { value: string }) => {
        const [expanded, setExpanded] = useState(false);
        const types = value?.split(", ") || [];

        const displayedTypes = expanded ? types : types?.slice(0, 2);
        const remainingCount = types?.length - 2;

        return (
            <Box
                sx={{
                    gap: 0.5,
                    alignItems: "center",
                    height: "100%",
                    margin: "5px 0 3px"
                }}
            >
                {displayedTypes?.map((type, idx) =>
                    type ? (
                        <Chip
                            key={idx}
                            label={type}
                            sx={{ margin: "5px 0px 0px 5px" }}
                            size="small"
                        />
                    ) : (
                        "N/A"
                    )
                )}
                {!expanded && remainingCount > 0 && (
                    <Chip
                        size="small"
                        label={`+${remainingCount}`}
                        sx={{ cursor: "pointer", margin: "5px 0px 0px 5px" }}
                        onClick={() => setExpanded(true)}
                    />
                )}
                {expanded && (
                    <IconButton
                        size="small"
                        onClick={() => setExpanded(false)}
                        sx={{ margin: "5px 0px 0px 5px" }}
                    >
                        <CancelIcon fontSize="small" />
                    </IconButton>
                )}
            </Box>
        );
    };

    const columns: GridColDef[] = [
        {
            field: "partNumber",
            headerName: "Part Number",
            width: 150,
            disableColumnMenu: true
        },
        {
            field: "partName",
            headerName: "Part Name",
            minWidth: 200,
            disableColumnMenu: true
        },
        // {
        //   field: "partGeneratedID",
        //   headerName: "Part ID",
        //   width: 200,
        //   disableColumnMenu: true,
        // },
        {
            field: "solution",
            headerName: "Solution",
            width: 200,
            disableColumnMenu: true,
            renderCell: (params) => <IndustryTypeCell value={params?.value} />
        },
        // {
        //   field: "process",
        //   headerName: "Process",
        //   minWidth: 200,
        //   disableColumnMenu: true,
        // },
        {
            field: "rawMaterial",
            headerName: "Raw Material",
            width: 180,
            disableColumnMenu: true
        },
        {
            field: "targetPrice",
            headerName: "Company Target Price",
            width: 150,
            disableColumnMenu: true,
            renderCell: (params) => {
                const value = params.value;
                const formattedValue = formatCurrencyValue(value);
                return (
                    // <Typography variant="body1">
                    //   {formattedValue === "0.00" ? "-" : `${formattedValue}`}
                    // </Typography>
                    <>
                        <div style={{ display: "block" }}>
                            <Typography
                                variant="body2"
                                display="flex"
                                alignItems="center"
                            >
                                {getCurrencyIcon(params?.row?.currency)}
                                <span style={{ paddingLeft: "5px" }}>
                                    {formattedValue}
                                </span>
                            </Typography>
                            <Typography
                                variant="caption"
                                color="text.secondary"
                                display="block"
                            >
                                {params?.row?.currency}
                            </Typography>
                        </div>
                    </>
                );
            }
        },
        {
            field: "suggestedPrice",
            headerName: "Suggested Price",
            width: 150,
            disableColumnMenu: true,
            renderCell: (params) => {
                const value = params?.value;
                const currency = params?.row?.Currency;
                const formattedValue = formatCurrencyValue(value, currency);
                return (
                    // <Typography variant="body1">
                    //   {formattedValue === "0.00" ? "-" : `${formattedValue}`}
                    // </Typography>
                    <>
                        <div style={{ display: "block" }}>
                            <Typography
                                variant="body2"
                                display="flex"
                                alignItems="center"
                            >
                                {getCurrencyIcon(params?.row?.currency)}
                                <span style={{ paddingLeft: "5px" }}>
                                    {formattedValue}
                                </span>
                            </Typography>
                            <Typography
                                variant="caption"
                                color="text.secondary"
                                display="block"
                            >
                                {params?.row?.currency}
                            </Typography>
                        </div>
                    </>
                );
            }
        },
        {
            field: "qty_yr",
            headerName: "Quantity/Year",
            minWidth: 130,
            disableColumnMenu: true,
            renderCell: (params) => {
                const value = params?.value;
                const formattedValue = formatCurrencyValue(value);
                return (
                    <Typography variant="body1">
                        {formattedValue === "0.00" ? "-" : `${formattedValue}`}
                    </Typography>
                );
            }
        },
        {
            field: "qty_batch",
            headerName: "Quantity/Batch",
            minWidth: 130,
            disableColumnMenu: true,
            renderCell: (params) => {
                const value = params?.value;
                const formattedValue = formatCurrencyValue(value);
                return (
                    <Typography variant="body1">
                        {formattedValue === "0.00" ? "-" : `${formattedValue}`}
                    </Typography>
                );
            }
        },
        {
            field: "uom",
            headerName: "UOM",
            width: 100,
            disableColumnMenu: true
        },
        {
            field: "totalOrderValue",
            headerName: "Total Part Value",
            width: 150,
            disableColumnMenu: true,
            renderCell: (params) => {
                const value = params.value;
                const currency = params?.row?.currency;
                const formattedValue = formatCurrencyValue(value, currency);
                return (
                    <>
                        <div style={{ display: "block" }}>
                            <Typography
                                variant="body2"
                                display="flex"
                                alignItems="center"
                            >
                                {getCurrencyIcon(params?.row?.currency)}
                                <span style={{ paddingLeft: "5px" }}>
                                    {formattedValue}
                                </span>
                            </Typography>
                            <Typography
                                variant="caption"
                                color="text.secondary"
                                display="block"
                            >
                                {params?.row?.currency}
                            </Typography>
                        </div>
                    </>
                );
            }
        },

        {
            field: "drawings",
            headerName: "Drawings",
            width: 200,
            disableColumnMenu: true,
            renderCell: (params) => {
                const drawings =
                    typeof params?.row?.drawings === "string" &&
                    params?.row?.drawings
                        ? [params.row.drawings]
                        : Array.isArray(params?.row?.drawings)
                          ? params.row.drawings
                          : [];

                const additional = Array.isArray(
                    params?.row?.additionalDrawingsPath
                )
                    ? params.row.additionalDrawingsPath.filter(
                          (p) => p && p.trim() !== ""
                      )
                    : [];

                const combined = [...drawings, ...additional];

                return combined.length > 0 ? (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {combined.map((_, index) => (
                            <Chip
                                key={index}
                                label={
                                    <span
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                            overflow: "hidden"
                                        }}
                                    >
                                        <img
                                            src={pdfFileImg}
                                            width="20px"
                                            alt="file"
                                        />
                                        {`Drawing ${index + 1}`}
                                    </span>
                                }
                                size="small"
                                className="hoverClr"
                                style={{
                                    cursor: "pointer",
                                    wordBreak: "break-all"
                                }}
                                onClick={() =>
                                    handleOpenDrawerDrawing(params?.row)
                                }
                            />
                        ))}
                    </Box>
                ) : (
                    "-"
                );
            }
        },

        {
            field: "3D Files",
            headerName: "3D Files",
            width: 250,
            disableColumnMenu: true,
            renderCell: (params) => <UploadFile params={params} />
        },
        // {
        //   field: "typeOfOrder",
        //   headerName: "Type Of Order",
        //   minWidth: 200,
        //   disableColumnMenu: true,
        //   renderCell: (params) => {
        //     if (!params?.value) {
        //       return "-";
        //     }
        //     return (
        //       <Chip
        //         variant="outlined"
        //         label={params?.value}
        //         size="small"
        //         color={params?.value === "Recurring Order" ? "info" : "warning"}
        //       />
        //     );
        //   },
        // },
        {
            field: "mandatoryInspection",
            headerName: "Mandatory Inspection",
            minWidth: 200,
            disableColumnMenu: true
        },
        {
            field: "packing",
            headerName: "Packing",
            minWidth: 100,
            disableColumnMenu: true,
            renderCell: (params) => {
                if (!params?.value) {
                    return "-";
                }
                return (
                    <Chip
                        variant="outlined"
                        label={params?.value}
                        size="small"
                        color={params?.value === "Yes" ? "success" : "error"}
                    />
                );
            }
        },
        {
            field: "sampleRequired",
            headerName: "Sample Required",
            minWidth: 100,
            disableColumnMenu: true,
            renderCell: (params) => {
                if (!params?.value) {
                    return "-";
                }
                return (
                    <Chip
                        variant="outlined"
                        label={params?.value}
                        size="small"
                        color={params?.value === "Yes" ? "success" : "error"}
                    />
                );
            }
        },

        {
            field: "documentsToBeSubmitted",
            headerName: "Documents to be Submitted",
            width: 200,
            disableColumnMenu: true,
            renderCell: (params) => {
                const docs =
                    (params?.value as string)
                        ?.split(",")
                        ?.map((doc) => doc?.trim()) || [];
                return (
                    <div>
                        {docs.map((doc, index) => (
                            <Chip
                                key={index}
                                label={doc}
                                size="small"
                                sx={{
                                    marginTop: "5px!important",
                                    marginRight: "5px"
                                }}
                            />
                        ))}
                    </div>
                );
            }
        }
        // {
        //   field: "leadTime",
        //   headerName: "Lead Time",
        //   width: 130,
        //   disableColumnMenu: true,
        //   renderCell: (params) => (
        //     <Chip
        //       size="small"
        //       variant="outlined"
        //       label={params?.value !== "-" ? `${params?.value} days` : "-"}
        //       color="primary"
        //       sx={{
        //         border: params?.value === "-" ? "none" : "",
        //       }}
        //     ></Chip>
        //   ),
        // },
    ];

    const HideColumns = useMemo(() => {
        return columns.filter((col) => {
            if (col.field === "targetPrice" || col.field === "suggestedPrice") {
                return filteredRows.some(
                    (row) => row[col.field] && Number(row[col.field]) !== 0
                );
            }
            return true;
        });
    }, [filteredRows]);

    const notificationUpdateReadStatus = async (id: string) => {
        try {
            const updateData = await notificationUpdateReadStatusApi({
                notifierID: id
            });
            if (updateData?.status) {
                updateIsReadStatus === true
                    ? setUpdateIsReadStatus(false)
                    : setUpdateIsReadStatus(true);
            }
        } catch (error) {
            console.log("eeeeeeeeeeeee", error);
        }
    };

    const processedNotificationIdsRef = useRef<Set<string>>(new Set());
    const rowsNotificationId = rowsGd?.notificationID;
    const routeNotificationId = rfqData?.notificationID;
    const getIsNewFlag = (value: any) =>
        value === true || value === "true" || value === 1 || value === "1";
    const rowsIsNew = getIsNewFlag(rowsGd?.isNew);
    const routeIsNew = getIsNewFlag(rfqData?.isNew);

    useEffect(() => {
        const targetNotificationId = rowsIsNew
            ? rowsNotificationId
            : routeIsNew
              ? routeNotificationId
              : null;

        if (
            !targetNotificationId ||
            processedNotificationIdsRef.current.has(targetNotificationId)
        ) {
            return;
        }

        processedNotificationIdsRef.current.add(targetNotificationId);
        notificationUpdateReadStatus(targetNotificationId);
    }, [rowsNotificationId, rowsIsNew, routeNotificationId, routeIsNew]);

    const fromPageLabelMap: Record<string, string> = {
        CompanyRfq: "Company RFQ",
        CURFQAssignedToMe: "Assigned CORFQs",
        FRfqList: "Feasible CORFQs",
        OrgRepo: "Organisation Repository",
        Proposals: "Proposals",
        DroppedRfq: "Dropped CORFQs"
    };

    let readableLabel = fromPageLabelMap[from] || from;
    if (from === "CompanyRfq") {
        readableLabel = "In Review";
    }
    if (from === "CURFQAssignedToMe") {
        readableLabel = "Assigned CORFQs";
    }
    if (from === "FRfqList") {
        readableLabel = "Feasible CORFQs";
    }
    if (from === "Proposals") {
        readableLabel = "Proposals";
    }
    if (from === "DroppedRfq") {
        readableLabel = "Dropped CORFQs";
    }
    let breadcrumbRoute = `/layout/${from}`;
    const isPastRfqEndDate =
        rowsGd?.rfqEndDate &&
        new Date(new Date(rowsGd?.rfqEndDate)?.toDateString()) <
            new Date(new Date()?.toDateString());

    // console.log("isPastRfqEndDate", isPastRfqEndDate);
    const isTodayOrFutureRfqEndDate =
        rowsGd?.rfqEndDate &&
        new Date(new Date(rowsGd?.rfqEndDate)?.toDateString()) >=
            new Date(new Date()?.toDateString());

    // console.log({
    //   isStatusUpdated,
    //   isPastRfqEndDate,
    //   isTodayOrFutureRfqEndDate,
    //   accountManagerHead: accountManagerHead(),
    //   accountManager: accountManager(),
    //   sourcingManager: sourcingManager(),
    //   status: finalApprovalReportDetails?.status,
    // });
    const currencyInr =
        rowsGd?.preferredCurrency === "INR" &&
        rowsGd?.totalOrderValue >= 5000000;
    const currencyEur =
        rowsGd?.preferredCurrency === "EUR" && rowsGd?.totalOrderValue >= 50000;
    const currencyUsd =
        rowsGd?.preferredCurrency === "USD" && rowsGd?.totalOrderValue >= 50000;

    // console.log("asdfsdfasd", rowsGd?.preferredCurrency);
    return (
        <>
            <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: "10px" }}>
                <Typography sx={{ fontSize: "14px" }}>
                    <Link
                        to="/layout/Dashboard"
                        style={{
                            color: "#0070BA",
                            fontSize: "14px",
                            textDecoration: "none"
                        }}
                    >
                        Home
                    </Link>
                </Typography>
                <Typography sx={{ fontSize: "14px" }}>
                    <Link
                        to={breadcrumbRoute}
                        style={{
                            color: "#0070BA",
                            fontSize: "14px",
                            textDecoration: "none"
                        }}
                    >
                        {readableLabel}
                    </Link>
                </Typography>
                <Typography
                    sx={{
                        fontSize: "14px",
                        color: "#00000099",
                        textDecoration: "none"
                    }}
                >
                    {rowsGd?.rfqName}
                </Typography>
            </Breadcrumbs>
            {/* {isStatusUpdated || finalApprovalReportDetails?.status ? (
        ""
      ) : (
        <Alert color="error" sx={{ marginBottom: "15px" }}>
          Review due date is {rowsGd?.rfqEndDate}. Please make sure all the
          approvers complete their review.
        </Alert>
        
      )} Due date is {rowsGd?.rfqEndDate}.*/}
            {/* StakeholderStatusChip */}
            {!isStatusUpdated &&
                (isPastRfqEndDate &&
                !accountManagerHead() &&
                !accountManager() &&
                !sourcingManager() &&
                !Management() &&
                (finalApprovalReportDetails?.status ===
                    "KAM Head Review Pending" ||
                    finalApprovalReportDetails?.status === "Rejected") ? (
                    <Alert severity="warning" sx={{ marginBottom: "15px" }}>
                        You cannot give an update on this RFQ as the end date (
                        {rowsGd?.rfqEndDate}) has been passed.
                    </Alert>
                ) : (
                    !finalApprovalReportDetails?.status &&
                    isTodayOrFutureRfqEndDate &&
                    (accountManagerHead() || accountManager() ? (
                        <Alert severity="error" sx={{ marginBottom: "15px" }}>
                            Review due date is {rowsGd?.rfqEndDate}. Please make
                            sure all the approvers complete their review.
                        </Alert>
                    ) : (
                        <Alert severity="error" sx={{ marginBottom: "15px" }}>
                            Review due date is {rowsGd?.rfqEndDate}. Please make
                            sure you complete your review.
                        </Alert>
                    ))
                ))}
            {(dropInfo?.isDropped || rowsGd?.isDropped) && (
                <Alert
                    color="warning"
                    sx={{ marginBottom: "15px", alignItems: "center" }}
                    icon={
                        <>
                            <Tooltip
                                title={
                                    dropInfo?.dropReason
                                        ? dropInfo?.dropReason
                                        : rowsGd?.droppedReason
                                }
                            >
                                <IconButton sx={{ padding: 0 }} color="warning">
                                    <InfoOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                        </>
                    }
                >
                    This CORFQ has been dropped by{" "}
                    {dropInfo?.droppedBy
                        ? dropInfo?.droppedBy
                        : rowsGd?.droppedByKamHead}{" "}
                    on{" "}
                    {dropInfo?.droppedTime.split(" ")[0]
                        ? dropInfo?.droppedTime.split(" ")[0]
                        : rowsGd?.addedTime.split(" ")[0]}
                </Alert>
            )}

            {/* {!isStatusUpdated &&
        isPastRfqEndDate &&
        (sourcingManagerHead() ||
          NPDManagerHead() ||
          productionManagerHead() ||
          qualityManagerHead()) &&
        (finalApprovalReportDetails?.status === "KAM Head Review Pending" ||
          finalApprovalReportDetails?.status === "Rejected") && (
          <Alert severity="warning" sx={{ marginBottom: "15px" }}>
            You cannot give an update on this RFQ as the end date (
            {rowsGd?.rfqEndDate}) has been passed.
          </Alert>
        )} */}

            <Box
                mb={2}
                sx={{ display: "flex", justifyContent: "space-between" }}
            >
                <Box
                    sx={{
                        width: { xs: "100%", sm: "100%", md: "55%" },
                        marginLeft: "10px"
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "15px"
                        }}
                    >
                        <Typography variant="h5" mr={2}>
                            {rowsGd?.rfqName}
                        </Typography>
                        {/* KamStatusChip */}
                        {(sourcingManagerHead() ||
                            NPDManagerHead() ||
                            productionManagerHead() ||
                            qualityManagerHead()) &&
                            feasibleReportDetails?.status && (
                                <>
                                    <Chip
                                        color={
                                            feasibleReportDetails?.status ===
                                            "Approved"
                                                ? "success"
                                                : feasibleReportDetails?.status ===
                                                    "Partially Approved"
                                                  ? "warning"
                                                  : feasibleReportDetails?.status ===
                                                      "Rejected"
                                                    ? "error"
                                                    : feasibleReportDetails?.status ===
                                                        "Pending"
                                                      ? "default"
                                                      : feasibleReportDetails?.status ===
                                                          "Verdict Not Given"
                                                        ? "default"
                                                        : "default"
                                        }
                                        variant="outlined"
                                        size="small"
                                        label={`${feasibleReportDetails?.status}`}
                                        sx={{
                                            padding: "0 4px",
                                            marginRight: "5px",
                                            ...(finalApprovalReportDetails?.status ===
                                            "Approvers Review Pending"
                                                ? {
                                                      borderColor:
                                                          "#F8B714!important",
                                                      color: " #F8B714!important",
                                                      backgroundColor:
                                                          " #f8b71417!important"
                                                  }
                                                : ""),
                                            ...((finalApprovalReportDetails?.status ===
                                                "Pending" ||
                                                finalApprovalReportDetails?.status ===
                                                    "Verdict Not Given") && {
                                                border: "1px solid #ccc",
                                                color: " #797979!important"
                                            })
                                        }}
                                    />
                                    {feasibleReportDetails?.reason && (
                                        <Tooltip
                                            title={
                                                feasibleReportDetails?.reason
                                            }
                                        >
                                            <IconButton>
                                                <InfoOutlinedIcon />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </>
                            )}
                    </Box>

                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ display: "flex" }}
                    >
                        Added on: {rowsGd?.addedOn}
                        {(currencyInr || currencyEur || currencyUsd) && (
                            <>
                                <span className="highlightCommonChip">
                                    High value{" "}
                                    <TrendingUpIcon sx={{ fontSize: "1rem" }} />
                                </span>
                            </>
                        )}
                    </Typography>
                    <Box
                        sx={{
                            display: "inline-flex",
                            alignItems: "center"
                        }}
                    >
                        <Typography variant="body2" color="text.secondary">
                            {rfqData?.rfqID}
                        </Typography>
                        <Divider
                            orientation="vertical"
                            sx={{ margin: "0 10px" }}
                            variant="middle"
                            flexItem
                        />
                        {accountManagerHead() ||
                        accountManager() ||
                        sourcingManager() ||
                        Management() ? (
                            <Chip
                                label={
                                    finalApprovalReportDetails?.status
                                        ? !finalApprovalReportDetails?.status?.includes(
                                              "KAM"
                                          )
                                            ? `${finalApprovalReportDetails?.status} by KAM Head`
                                            : finalApprovalReportDetails?.status
                                        : isAllReviewed
                                          ? "KAM Head Review Pending"
                                          : "Approvers Review Pending"
                                }
                                color={
                                    finalApprovalReportDetails?.status ===
                                    "Approved"
                                        ? "success"
                                        : finalApprovalReportDetails?.status ===
                                            "Rejected"
                                          ? "error"
                                          : "warning"
                                }
                                variant="outlined"
                                size="small"
                                sx={{
                                    padding: "0 4px",
                                    marginRight: "5px",
                                    ...(finalApprovalReportDetails?.status ===
                                        "Approvers Review Pending" && {
                                        borderColor: " #F8B714!important",
                                        color: " #F8B714!important"
                                    })
                                }}
                            />
                        ) : null}
                        {/* AprRjctTooltip */}
                        {(accountManagerHead() ||
                            accountManager() ||
                            sourcingManager() ||
                            Management()) &&
                            finalApprovalReportDetails?.reason &&
                            (finalApprovalReportDetails?.status ===
                                "Approved" ||
                                finalApprovalReportDetails?.status ===
                                    "Rejected") && (
                                <Tooltip
                                    title={finalApprovalReportDetails?.reason}
                                >
                                    <IconButton>
                                        <InfoOutlinedIcon />
                                    </IconButton>
                                </Tooltip>
                            )}

                        {/* //HeadAprStatusChip */}
                        {(sourcingManagerHead() ||
                            NPDManagerHead() ||
                            productionManagerHead() ||
                            qualityManagerHead()) && (
                            <Chip
                                label={
                                    finalApprovalReportDetails?.status
                                        ? finalApprovalReportDetails?.status !==
                                          "KAM Head Review Pending"
                                            ? `${finalApprovalReportDetails?.status} by KAM Head`
                                            : finalApprovalReportDetails?.status
                                        : isStatusUpdated
                                          ? "KAM Head Review Pending"
                                          : "Approvers Review Pending"
                                }
                                color={
                                    finalApprovalReportDetails?.status ===
                                    "Approved"
                                        ? "success"
                                        : finalApprovalReportDetails?.status ===
                                            "Rejected"
                                          ? "error"
                                          : "warning"
                                }
                                variant="outlined"
                                size="small"
                                sx={{
                                    padding: "0 4px",
                                    marginRight: "5px",
                                    ...(finalApprovalReportDetails?.status ===
                                        "Approvers Review Pending" && {
                                        borderColor: "#F8B714!important",
                                        color: " #F8B714!important",
                                        backgroundColor: " #f8b71417!important"
                                    })
                                }}
                            />
                        )}
                        {/* HeadReasonTooltip */}
                        {(sourcingManagerHead() ||
                            NPDManagerHead() ||
                            productionManagerHead() ||
                            qualityManagerHead()) &&
                        finalApprovalReportDetails?.reason !== "" &&
                        finalApprovalReportDetails?.reason?.trim() ? (
                            <Tooltip title={finalApprovalReportDetails?.reason}>
                                <IconButton>
                                    <InfoOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                        ) : null}

                        <Divider
                            orientation="vertical"
                            sx={{ margin: "0 10px" }}
                            variant="middle"
                            flexItem
                        />

                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ display: "flex", alignItems: "center" }}
                        >
                            Approvers:
                            <AvatarGroup
                                spacing="small"
                                sx={{
                                    "& .MuiAvatarGroup-avatar": {
                                        width: "30px",
                                        height: "30px",
                                        fontSize: "1rem"
                                    }
                                }}
                            >
                                {Array.isArray(approvers) &&
                                approvers?.length > 0 ? (
                                    approvers?.map((approver, index) => {
                                        if (!approver) return null;
                                        const url = generatProfilePicUrl(
                                            approver?.profileFileID,
                                            approver?.profileFileName,
                                            "Profile_Picture"
                                        );
                                        return (
                                            <div
                                                key={
                                                    approver?.profileFileID ||
                                                    index
                                                }
                                                className="p-2 border rounded shadow"
                                            >
                                                <Avatar
                                                    alt={
                                                        approver?.profileName ||
                                                        "Approver"
                                                    }
                                                    src={url || ""}
                                                    sx={{
                                                        width: "30px",
                                                        height: "30px"
                                                    }}
                                                />
                                            </div>
                                        );
                                    })
                                ) : (
                                    <p>No approvers found.</p>
                                )}
                            </AvatarGroup>
                        </Typography>
                    </Box>
                </Box>
                <Box
                    sx={{
                        width: { xs: "100%", md: "55%", sm: "100%" },
                        display: "flex",
                        justifyContent: "end",
                        alignItems: "end",
                        paddingBottom: "5px"
                    }}
                >
                    {feasibleReportDetails?.status === "Partially Approved" &&
                        (sourcingManagerHead() ||
                            NPDManagerHead() ||
                            productionManagerHead() ||
                            qualityManagerHead()) && (
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={() => handleOpenPartsDrawer()}
                                sx={{ marginRight: "5px" }}
                            >
                                View Approved Parts
                            </Button>
                        )}
                    <Button
                        size="small"
                        variant="outlined"
                        onClick={() => handleOpenDrawer()}
                        sx={{ marginRight: "5px" }}
                    >
                        Check Approval Status
                    </Button>
                    {(finalApprovalReportDetails?.status ===
                        "KAM Head Review Pending" ||
                        isAllReviewed) &&
                        finalApprovalReportDetails?.status !== "Approved" &&
                        finalApprovalReportDetails?.status !== "Rejected" &&
                        accountManagerHead() && (
                            <>
                                <Button
                                    size="small"
                                    variant="contained"
                                    color="success"
                                    sx={{ marginRight: "5px" }}
                                    onClick={() =>
                                        handleClickOpenAR("Approved")
                                    }
                                    disabled={!isAllReviewed && isRfqDateEnd}
                                >
                                    Approve
                                </Button>
                                <Button
                                    size="small"
                                    variant="contained"
                                    color="error"
                                    sx={{ marginRight: "5px" }}
                                    onClick={() =>
                                        handleClickOpenAR("Rejected")
                                    }
                                    disabled={!isAllReviewed && isRfqDateEnd}
                                >
                                    Reject
                                </Button>
                            </>
                        )}
                    {!isStatusUpdated &&
                        (sourcingManagerHead() ||
                            qualityManagerHead() ||
                            productionManagerHead() ||
                            NPDManagerHead()) && (
                            <>
                                <Button
                                    size="small"
                                    variant="contained"
                                    color="success"
                                    sx={{ marginRight: "5px" }}
                                    onClick={() =>
                                        handleClickOpenAR("Approved")
                                    }
                                    disabled={!isRfqDateEnd}
                                >
                                    Approve
                                </Button>
                                <Button
                                    size="small"
                                    variant="contained"
                                    color="error"
                                    sx={{ marginRight: "5px" }}
                                    onClick={() =>
                                        handleClickOpenAR("Rejected")
                                    }
                                    disabled={!isRfqDateEnd}
                                >
                                    Reject
                                </Button>
                                <Button
                                    size="small"
                                    variant="contained"
                                    color="warning"
                                    disabled={!isRfqDateEnd}
                                    onClick={() =>
                                        handleClickOpenAR("Partially Approved")
                                    }
                                >
                                    Partially Approve
                                </Button>
                            </>
                        )}
                    {accountManagerHead() &&
                        finalApprovalReportDetails?.status === "Approved" &&
                        (from === "FRfqList" || "Proposals") &&
                        !isCopoCreated && (
                            <Button
                                size="small"
                                variant="contained"
                                color="warning"
                                disabled={
                                    dropInfo?.isDropped
                                        ? dropInfo?.isDropped
                                        : rowsGd?.isDropped
                                }
                                onClick={() => handleClickOpenAR("Dropped")}
                            >
                                Drop CORFQ
                            </Button>
                        )}
                </Box>
                <ApprovalStatusDrawer
                    open={openDrawer}
                    onClose={handleCloseDrawer}
                    isRfqDateEnd={isRfqDateEnd}
                    row={selectedRows}
                    approvers={approvers}
                    rawRfqID={rfqData?.ID}
                />
                <PartsDrawer
                    open={openDrawerParts}
                    onClose={handleClosePartsDrawer}
                    selectedCORFQID={rfqData?.ID}
                    isStatusUpdated={isStatusUpdated}
                />
                {/* popup for approve reject Partially approve */}

                <Dialog open={openDialogAR} onClose={handleCloseAR}>
                    <DialogTitle
                        sx={{ paddingBottom: "5px" }}
                        fontWeight={"bold"}
                    >
                        {actionType === "Partially Approved"
                            ? "Partially Approve"
                            : actionType === "Approved"
                              ? "Approve"
                              : actionType === "Dropped"
                                ? "Drop"
                                : actionType === "Rejected" && "Reject"}{" "}
                        {rfqData?.rfqID}
                    </DialogTitle>
                    <DialogContent sx={{ paddingBottom: "10px" }}>
                        <DialogContentText
                            marginBottom={"15px"}
                            fontSize={"0.875rem"}
                        >
                            {accountManagerHead() &&
                                actionType === "Dropped" && (
                                    <>
                                        Dropping a CORFQ is a one time action
                                        and cannot be reversed. Dropping will
                                        terminate the CORFQ’s journey instantly.{" "}
                                    </>
                                )}
                            {actionType !== "Dropped" && (
                                <>
                                    Are you sure you want to {statusPresentense}{" "}
                                    {rfqData?.rfqID}
                                    {accountManagerHead() &&
                                    archiveCount > 0 ? (
                                        <>
                                            {/* , Are you sure you want to{" "}
                                    {statusPresentense} {rfqData?.rfqID}  */}{" "}
                                            with{" "}
                                            <a
                                                onClick={() => {
                                                    setValue("2");
                                                    handleCloseAR();
                                                }}
                                                style={{
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    textDecoration: "underline"
                                                }}
                                            >
                                                {archiveCount} parts{" "}
                                            </a>
                                            archived?
                                        </>
                                    ) : (
                                        "?"
                                    )}
                                </>
                            )}
                        </DialogContentText>
                        {actionType === "Partially Approved" && (
                            <Autocomplete
                                multiple
                                limitTags={2}
                                id="multiple-limit-tags"
                                options={
                                    [...partiallyApproveParts]?.sort((a, b) =>
                                        a?.partName?.localeCompare(b?.partName)
                                    ) ||
                                    [...partiallyApproveParts]?.sort(
                                        (a, b) => a?.partID - b?.partID
                                    )
                                }
                                size="small"
                                getOptionLabel={(option) => option?.title}
                                onChange={(event, newValue) => {
                                    setSelectedPartValues(
                                        newValue?.map((item) => item?.partID)
                                    ); // Extract IDs
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Part Names"
                                        placeholder="Select Part Names"
                                    />
                                )}
                                sx={{ marginBottom: "10px" }}
                            />
                        )}
                        {accountManagerHead() && actionType === "Approved" && (
                            <Autocomplete
                                disablePortal
                                options={departments}
                                getOptionLabel={(option) =>
                                    option.Department_Name
                                }
                                value={selectedDepartment}
                                onChange={(event, value) =>
                                    setSelectedDepartment(value)
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select Department"
                                    />
                                )}
                                sx={{ marginBottom: "1rem" }}
                            />
                        )}

                        <TextField
                            id="outlined-multiline-static"
                            label={
                                actionType === "Dropped"
                                    ? "Reason to Drop"
                                    : "Add your comments"
                            }
                            fullWidth
                            multiline
                            rows={4}
                            value={reasonForStatus}
                            onChange={(e) =>
                                setReasonForStatus(e?.target?.value)
                            }
                            defaultValue=""
                        />
                    </DialogContent>

                    <DialogActions>
                        <Button
                            size="small"
                            onClick={handleCloseAR}
                            color="error"
                        >
                            Cancel
                        </Button>
                        {accountManagerHead() && (
                            <Button
                                size="small"
                                type="submit"
                                disabled={
                                    (actionType === "Approved" &&
                                        !selectedDepartment) ||
                                    reasonForStatus?.length <= 0 ||
                                    isSubmitting
                                }
                                onClick={() =>
                                    handleStatusUpdateByKamHead(
                                        actionType,
                                        reasonForStatus
                                    )
                                }
                            >
                                {isSubmitting
                                    ? "Processing..."
                                    : actionType === "Approved"
                                      ? "Send Approval"
                                      : actionType === "Dropped"
                                        ? "Drop CORFQ"
                                        : "Send Rejection"}
                            </Button>
                        )}
                        {(sourcingManagerHead() ||
                            NPDManagerHead() ||
                            qualityManagerHead() ||
                            productionManagerHead()) && (
                            <Button
                                size="small"
                                type="submit"
                                disabled={
                                    isSubmitting ||
                                    (actionType === "Partially Approved"
                                        ? reasonForStatus?.length <= 0 ||
                                          selectedPartValues.length <= 0
                                        : reasonForStatus?.length <= 0)
                                }
                                onClick={() =>
                                    handleStatusUpdate(
                                        actionType,
                                        reasonForStatus
                                    )
                                }
                            >
                                {isSubmitting
                                    ? "Processing..."
                                    : actionType === "Partially Approved"
                                      ? "Partially Approve"
                                      : actionType === "Approved"
                                        ? "Approve"
                                        : "Reject"}
                            </Button>
                        )}
                    </DialogActions>
                </Dialog>
            </Box>

            <Accordion
                sx={{
                    marginBottom: "15px",
                    borderRadius: "5px",
                    boxShadow: "none"
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <Typography component="span">General Details</Typography>
                </AccordionSummary>
                <AccordionDetails
                    sx={{
                        padding: "0 5px 10px 5px",
                        borderTop: "1px solid #ccc"
                    }}
                >
                    <TableContainer
                        component={Paper}
                        sx={{ boxShadow: "none" }}
                    >
                        <Table aria-label="simple table">
                            {rowsGd ? (
                                <>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>
                                                Company Name
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                RFQ Start Date
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                RFQ End Date
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                Total Order Value
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                Type of Order
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                Industry Type
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                Key Account Manager
                                            </StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow
                                            key=""
                                            sx={{
                                                "&:last-child td, &:last-child th":
                                                    { border: 0 }
                                            }}
                                        >
                                            <>
                                                <StyledBodyCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    {rowsGd?.companyName || "-"}
                                                </StyledBodyCell>
                                                <StyledBodyCell>
                                                    {rowsGd?.rfqStartDate ||
                                                        "-"}
                                                </StyledBodyCell>
                                                <StyledBodyCell>
                                                    {rowsGd?.rfqEndDate || "-"}
                                                </StyledBodyCell>
                                                <StyledBodyCell
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    {getCurrencyIcon(
                                                        rowsGd?.preferredCurrency
                                                    )}
                                                    {formatCurrencyValue(
                                                        rowsGd?.totalOrderValue,
                                                        rowsGd?.preferredCurrency
                                                    )}
                                                    {rowsGd?.priceType && (
                                                        <Tooltip
                                                            title={
                                                                rowsGd.priceType
                                                            }
                                                        >
                                                            <IconButton size="small">
                                                                <InfoOutlinedIcon
                                                                    style={{
                                                                        fontSize:
                                                                            "16px"
                                                                    }}
                                                                />
                                                            </IconButton>
                                                        </Tooltip>
                                                    )}
                                                </StyledBodyCell>
                                                <StyledBodyCell>
                                                    {/* {rowsGd?.typeOfOrder || "-"} */}
                                                    <Chip
                                                        variant="outlined"
                                                        label={
                                                            rowsGd?.typeOfOrder
                                                        }
                                                        size="small"
                                                        color={
                                                            rowsGd?.typeOfOrder ===
                                                            "Recurring Order"
                                                                ? "info"
                                                                : "warning"
                                                        }
                                                    />
                                                </StyledBodyCell>
                                                <StyledBodyCell>
                                                    {rowsGd?.industryType ||
                                                        "-"}
                                                </StyledBodyCell>

                                                <StyledBodyCell>
                                                    <Grid
                                                        container
                                                        spacing={2}
                                                        alignItems="center"
                                                        width="100%"
                                                    >
                                                        <Grid
                                                            size={{
                                                                xs: 2,
                                                                md: 2
                                                            }}
                                                        >
                                                            <img
                                                                src={
                                                                    generatProfilePicUrl(
                                                                        rowsGd?.keyAccountManagerID,
                                                                        rowsGd?.keyAccountManagerProfilePath,
                                                                        "Profile_Picture"
                                                                    ) || ""
                                                                }
                                                                alt="KAM"
                                                                width={28}
                                                                height={28}
                                                                style={{
                                                                    marginRight:
                                                                        "5px",
                                                                    borderRadius:
                                                                        "50%"
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            size={{
                                                                xs: 10,
                                                                md: 10
                                                            }}
                                                        >
                                                            <Typography
                                                                variant="body2"
                                                                className=""
                                                            >
                                                                {
                                                                    rowsGd?.keyAccountManager
                                                                }
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </StyledBodyCell>
                                            </>
                                        </TableRow>
                                    </TableBody>
                                </>
                            ) : (
                                <TableRow>
                                    <StyledBodyCell
                                        colSpan={1}
                                        sx={{ textAlign: "center" }}
                                    >
                                        No General Details Available
                                    </StyledBodyCell>
                                </TableRow>
                            )}
                        </Table>
                    </TableContainer>
                </AccordionDetails>
            </Accordion>
            <Accordion
                sx={{
                    marginBottom: "15px",
                    borderRadius: "5px",
                    boxShadow: "none"
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                    sx={{ margin: "0" }}
                >
                    <Typography component="span">
                        Mandatory Certifications
                    </Typography>
                </AccordionSummary>
                <AccordionDetails
                    sx={{
                        padding: "0 5px 10px 5px",
                        borderTop: "1px solid #ccc"
                    }}
                >
                    <TableContainer
                        component={Paper}
                        sx={{ boxShadow: "none" }}
                    >
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    {rowsGd?.mandatoryCertifications?.length >
                                        0 && (
                                        <>
                                            {rowsGd?.mandatoryCertifications?.map(
                                                (item, index) => (
                                                    <StyledTableCell
                                                        key={index}
                                                    >
                                                        Certificate {index + 1}
                                                    </StyledTableCell>
                                                )
                                            )}
                                        </>
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rowsGd &&
                                rowsGd?.mandatoryCertifications?.length > 0 ? (
                                    <TableRow
                                        sx={{
                                            "&:last-child td, &:last-child th":
                                                { border: 0 }
                                        }}
                                    >
                                        {rowsGd?.mandatoryCertifications?.map(
                                            (cert, index) => (
                                                <StyledBodyCell key={index}>
                                                    {cert}
                                                </StyledBodyCell>
                                            )
                                        )}
                                    </TableRow>
                                ) : (
                                    <TableRow>
                                        <StyledBodyCell
                                            colSpan={1}
                                            sx={{ textAlign: "center" }}
                                        >
                                            No Certification Available
                                        </StyledBodyCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </AccordionDetails>
            </Accordion>

            <Typography variant="h5" mb={1}>
                Part Listing
            </Typography>

            <Box
                sx={{
                    borderRadius: "5px",
                    marginTop: "16px",
                    background: "#fff",
                    padding: "24px"
                }}
            >
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <TabList
                            onChange={handleChange}
                            aria-label="lab API tabs example"
                        >
                            <Tab label="ALL" value="1" />
                            <Tab
                                label={`Archive (${archiveCount})`}
                                value="2"
                            />
                        </TabList>
                    </Box>
                    <TabPanel value="1" sx={{ padding: "20px 0" }}>
                        <Grid container spacing={2} mb={0}>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Grid container spacing={2}>
                                    {/* Search Section */}
                                    {rows?.length > 1 && (
                                        <Grid size={{ xs: 12, md: 7 }}>
                                            <TextField
                                                label="Search by Part No & Part Name"
                                                size="small"
                                                variant="outlined"
                                                fullWidth
                                                inputRef={searchInputRef}
                                                value={searchTerm}
                                                onChange={handleSearch}
                                            />
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <>
                                    <div style={{ float: "right" }}>
                                        {value === "1" &&
                                            selectedRows?.length > 0 && (
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="small"
                                                    disabled={
                                                        isArchiveOrUnarchiveLoading ||
                                                        finalApprovalReportDetails?.status ===
                                                            "Approved" ||
                                                        finalApprovalReportDetails?.status ===
                                                            "Rejected" ||
                                                        filteredRows?.length <=
                                                            1 ||
                                                        selectedRows?.length ===
                                                            filteredRows?.length
                                                    }
                                                    onClick={handleClickOpen}
                                                >
                                                    Archive
                                                </Button>
                                            )}
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            sx={{ marginLeft: "10px" }}
                                            onClick={handleAllFilesDownload}
                                        >
                                            Download All
                                        </Button>
                                    </div>
                                    <Dialog
                                        open={openDialog}
                                        onClose={handleClose}
                                    >
                                        <DialogTitle
                                            sx={{ paddingBottom: "5px" }}
                                        >
                                            <b>
                                                Archive{" "}
                                                {RowsForArchiveAndUnarchive?.length ||
                                                    0}{" "}
                                                part(s)
                                            </b>
                                        </DialogTitle>
                                        <DialogContent
                                            sx={{ paddingBottom: "10px" }}
                                        >
                                            <div
                                                style={{ marginBottom: "10px" }}
                                            >
                                                <Typography>
                                                    Are you sure you want to
                                                    archive{" "}
                                                    {RowsForArchiveAndUnarchive?.length ||
                                                        0}{" "}
                                                    part(s) ?
                                                </Typography>
                                            </div>
                                            {RowsForArchiveAndUnarchive?.map(
                                                (item) => {
                                                    return (
                                                        <Chip
                                                            label={
                                                                item?.partName
                                                            }
                                                            size="small"
                                                            sx={{
                                                                marginRight:
                                                                    "8px",
                                                                marginBottom:
                                                                    "5px"
                                                            }}
                                                        />
                                                    );
                                                }
                                            )}
                                        </DialogContent>
                                        <DialogActions>
                                            <Button
                                                size="small"
                                                onClick={handleClose}
                                                color="error"
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                size="small"
                                                type="submit"
                                                disabled={
                                                    isArchiveOrUnarchiveLoading
                                                }
                                                onClick={() =>
                                                    handleArchiveAndUnarchive(
                                                        "Yes"
                                                    )
                                                }
                                            >
                                                Confirm
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                </>
                            </Grid>
                        </Grid>
                        <Paper
                            sx={{
                                height:
                                    filteredRows?.length > 4 ? "500px" : "auto",
                                marginTop: "15px",
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            {!isLoading ? (
                                filteredRows?.length > 0 ? (
                                    <DataGridPro
                                        pinnedColumns={pinnedColumns}
                                        onPinnedColumnsChange={
                                            handlePinnedColumnsChange
                                        }
                                        getRowHeight={() => "auto"}
                                        rows={filteredRows}
                                        columns={HideColumns}
                                        pagination={filteredRows?.length > 10}
                                        checkboxSelection={
                                            accountManagerHead() &&
                                            filteredRows?.length > 1 &&
                                            finalApprovalReportDetails?.status !==
                                                "Approved"
                                        }
                                        paginationModel={paginationModel}
                                        onPaginationModelChange={
                                            setPaginationModel
                                        }
                                        pageSizeOptions={[10, 20]}
                                        rowSelectionModel={selectedRows}
                                        onRowSelectionModelChange={
                                            handleSelectionChange
                                        }
                                        disableRowSelectionOnClick={true}
                                        sx={{
                                            width: "100%",
                                            "& .MuiDataGrid-columnHeaderTitleContainer":
                                                {
                                                    "& .MuiDataGrid-sortIcon": {
                                                        opacity: "1 !important",
                                                        visibility:
                                                            "visible !important"
                                                    }
                                                },
                                            "& .MuiDataGrid-cell": {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            "& .MuiDataGrid-scrollbarFiller--pinnedRight":
                                                {
                                                    backgroundColor:
                                                        "#F4F4F4!important"
                                                }
                                        }}
                                    />
                                ) : (
                                    <>
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                gap: "8px",
                                                padding: "20px",
                                                color: "#0009"
                                            }}
                                        >
                                            {searchTerm &&
                                            filteredRows?.length == 0 ? (
                                                "No Options available"
                                            ) : (
                                                <>
                                                    <img
                                                        src={emptyImage}
                                                        alt="Empty"
                                                        width={"300px"}
                                                    />
                                                    <b>No Parts</b>
                                                </>
                                            )}
                                        </div>
                                    </>
                                )
                            ) : (
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="50vh"
                                >
                                    <ThreeDot
                                        color="#1976d2"
                                        size="medium"
                                        text=""
                                        textColor=""
                                    />
                                </Box>
                            )}
                        </Paper>
                    </TabPanel>
                    <TabPanel value="2" sx={{ padding: "20px 0" }}>
                        <Grid container spacing={2} mb={0}>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Grid
                                    container
                                    spacing={2}
                                    sx={{ marginBottom: "0px" }}
                                >
                                    {/* Search Section */}
                                    {rows?.length > 1 && (
                                        <Grid size={{ xs: 12, md: 7 }}>
                                            <TextField
                                                label="Search by Part Number & Part Name"
                                                size="small"
                                                variant="outlined"
                                                fullWidth
                                                inputRef={searchInputRef}
                                                value={searchTerm}
                                                onChange={handleSearch}
                                            />
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                {value === "2" && selectedRows?.length > 0 && (
                                    <>
                                        <div style={{ float: "right" }}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="small"
                                                disabled={
                                                    isArchiveOrUnarchiveLoading ||
                                                    finalApprovalReportDetails?.status ===
                                                        "Approved" ||
                                                    finalApprovalReportDetails?.status ===
                                                        "Rejected"
                                                }
                                                onClick={handleClickOpen}
                                            >
                                                Unarchive
                                            </Button>
                                        </div>
                                        <Dialog
                                            open={openDialog}
                                            onClose={handleClose}
                                        >
                                            <DialogTitle
                                                sx={{ paddingBottom: "5px" }}
                                            >
                                                <b>
                                                    Unarchive{" "}
                                                    {RowsForArchiveAndUnarchive?.length ||
                                                        0}{" "}
                                                    part(s)
                                                </b>
                                            </DialogTitle>
                                            <DialogContent
                                                sx={{ paddingBottom: "10px" }}
                                            >
                                                <div
                                                    style={{
                                                        marginBottom: "10px"
                                                    }}
                                                >
                                                    <Typography>
                                                        Are you sure you want to
                                                        unarchive{" "}
                                                        {RowsForArchiveAndUnarchive?.length ||
                                                            0}{" "}
                                                        part(s)?
                                                    </Typography>
                                                </div>
                                                {RowsForArchiveAndUnarchive?.map(
                                                    (item) => (
                                                        <Chip
                                                            key={item?.partName}
                                                            label={
                                                                item?.partName
                                                            }
                                                            size="small"
                                                            sx={{
                                                                marginRight:
                                                                    "8px",
                                                                marginBottom:
                                                                    "5px"
                                                            }}
                                                        />
                                                    )
                                                )}
                                            </DialogContent>
                                            <DialogActions>
                                                <Button
                                                    size="small"
                                                    onClick={handleClose}
                                                    color="error"
                                                >
                                                    Cancel
                                                </Button>
                                                <Button
                                                    size="small"
                                                    type="submit"
                                                    disabled={
                                                        isArchiveOrUnarchiveLoading
                                                    }
                                                    onClick={() =>
                                                        handleArchiveAndUnarchive(
                                                            "No"
                                                        )
                                                    }
                                                >
                                                    Confirm
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </>
                                )}
                            </Grid>
                        </Grid>
                        <Paper
                            sx={{
                                // height: 400,
                                height:
                                    filteredRows?.length > 4 ? "500px" : "auto",
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "15px"
                            }}
                        >
                            {!isLoading ? (
                                filteredRows?.length > 0 ? (
                                    <DataGridPro
                                        pinnedColumns={pinnedColumns}
                                        onPinnedColumnsChange={
                                            handlePinnedColumnsChange
                                        }
                                        getRowHeight={() => "auto"}
                                        rows={filteredRows}
                                        columns={columns}
                                        pagination={filteredRows?.length > 10}
                                        checkboxSelection={
                                            accountManagerHead() &&
                                            filteredRows?.length > 0
                                        }
                                        paginationModel={paginationModel}
                                        onPaginationModelChange={
                                            setPaginationModel
                                        }
                                        pageSizeOptions={[10, 20]}
                                        rowSelectionModel={selectedRows}
                                        onRowSelectionModelChange={
                                            handleSelectionChange
                                        }
                                        disableRowSelectionOnClick={true}
                                        sx={{
                                            "& .MuiDataGrid-columnHeaderTitleContainer":
                                                {
                                                    "& .MuiDataGrid-sortIcon": {
                                                        opacity: "1 !important",
                                                        visibility:
                                                            "visible !important"
                                                    }
                                                },
                                            "& .MuiDataGrid-cell": {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            "& .MuiDataGrid-scrollbarFiller--pinnedRight":
                                                {
                                                    backgroundColor:
                                                        "#F4F4F4!important"
                                                }
                                        }}
                                    />
                                ) : (
                                    <>
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                gap: "8px",
                                                padding: "20px",
                                                color: "#0009"
                                            }}
                                        >
                                            {searchTerm ? (
                                                "No Options available"
                                            ) : (
                                                <>
                                                    <img
                                                        src={emptyImage}
                                                        alt="Empty"
                                                        width={"300px"}
                                                    />
                                                    <b>
                                                        No RFQ Parts Archived
                                                        yet
                                                    </b>
                                                </>
                                            )}
                                        </div>
                                    </>
                                )
                            ) : (
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="50vh"
                                >
                                    <ThreeDot
                                        color="#1976d2"
                                        size="medium"
                                        text=""
                                        textColor=""
                                    />
                                </Box>
                            )}
                        </Paper>
                    </TabPanel>
                </TabContext>
                <DrawingDrawer
                    open={openDrawerDrawing}
                    onClose={handleCloseDrawerDrawing}
                    selectedRowData={selectedRowData}
                    partID={selectedRowData?.partID || ""}
                    onRefresh={handleRefreshAfterUpload}
                    from={from}
                />
                <StepFile
                    open={openDrawerStepFile}
                    onClose={handleCloseStepFile}
                    setDeleteStepFile={setDeleteStepFile}
                    selectedRowData={selectedRowData}
                    finalApprovalReportDetails={finalApprovalReportDetails}
                />
            </Box>
        </>
    );
};
